import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  NgZone, OnDestroy,
  OnInit,
} from '@angular/core';
import {Tools} from "linkurious-shared";

@Component({
  selector: 'menu',
  template: `<div class="menu_list" [class.menu_list--icon]="hasIcon">
  <ng-content></ng-content>
</div>
`,
  styles: [`.menu_list--compact .menu_action{padding:0 20px!important}.menu_list--bordered{border-radius:3px;box-shadow:0 1px 3px rgba(0,0,0,.12),0 1px 2px rgba(0,0,0,.24);-webkit-box-shadow:0 1px 3px rgba(0,0,0,.12),0 1px 2px rgba(0,0,0,.24);-moz-box-shadow:0 1px 3px rgba(0,0,0,.12),0 1px 2px rgba(0,0,0,.24);-ms-box-shadow:0 1px 3px rgba(0,0,0,.12),0 1px 2px rgba(0,0,0,.24);-o-box-shadow:0 1px 3px rgba(0,0,0,.12),0 1px 2px rgba(0,0,0,.24)}.menu_list{padding:5px 0;background:#fff;outline:0}.menu_list.is__sub_menu{position:fixed;visibility:hidden;opacity:0;transition:opacity ease-in-out .3s}.menu_list.is__sub_menu.active{visibility:visible;opacity:1}.menu_list hr{border:0;border-top:1px solid #cbcbcb;margin:5px 0}.menu_list.menu_list--icon a.menu_action,.menu_list.menu_list--icon button.menu_action{padding-left:45px}`],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MenuComponent implements OnInit, OnDestroy, AfterViewInit {

  public hasIcon: boolean;
  private _parent: HTMLElement;

  constructor(
    public elementRef: ElementRef,
    private _ngZone: NgZone,
    private _detectorRef: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this._ngZone.runOutsideAngular(() => {
      window.addEventListener('resize', this.onResize.bind(this));
      document.addEventListener('scroll', this.onScroll.bind(this));
    });
  }

  ngOnDestroy() {
    window.removeEventListener('resize', this.onResize.bind(this));
    document.removeEventListener('scroll', this.onScroll.bind(this));
    if ( this._parent ) {
      window.removeEventListener('mousemove', this.moveOutside.bind(this));
    }
  }

  ngAfterViewInit() {
    if ( this.elementRef.nativeElement.querySelectorAll('button .action_icon').length > 0 ) {
      this.hasIcon = true;
      this._detectorRef.markForCheck();
    }
  }

  private onResize() {
    if ( Tools.isDefined(this.elementRef.nativeElement.closest('button')) ) {
      this.setPosition(this.elementRef.nativeElement.closest('button').getBoundingClientRect());
    }
  }

  private onScroll() {
    if ( Tools.isDefined(this.elementRef.nativeElement.closest('button')) ) {
      this.setPosition(this.elementRef.nativeElement.closest('button').getBoundingClientRect());
    }
  }

  /**
   * Set the position of the menu if it's a submenu
   */
  private setPosition(parentPosition: {bottom: number; height: number; left: number; right: number; top: number; width: number}) {
    let subMenu = this.elementRef.nativeElement.getElementsByClassName('menu_list')[0];
    subMenu.style.width = Tools.numberToPixels(parentPosition.width);
    this._detectorRef.markForCheck();
    let html = document.documentElement;
    let viewPortHeight = document.documentElement.clientHeight;
    let viewPortWidth = html.clientWidth;
    let baseTop = parentPosition.top - 5;
    let baseLeft = parentPosition.left + parentPosition.width + 1;

    if ( baseLeft + parentPosition.width > viewPortWidth ) {
      baseLeft = parentPosition.left - subMenu.offsetWidth;
    }
    if ( subMenu.offsetHeight + parentPosition.top - 5 > viewPortHeight ) {
      let testTop = parentPosition.bottom - subMenu.offsetHeight + 5;
      baseTop = (testTop < 0) ? 5 : testTop;
    }
    subMenu.style.top = Tools.numberToPixels(baseTop);
    subMenu.style.left = Tools.numberToPixels(baseLeft);
    this._detectorRef.markForCheck();
  }

  private moveOutside(e: any): void {
    if ( !this._parent.contains(e.target) && !this.elementRef.nativeElement.contains(e.target) ) {
      this.hide();
    }
  }

  public show(position: {
    top: number;
    bottom: number;
    left: number;
    right: number;
    width: number;
    height: number
  }): void {
    setTimeout(() => {
      this.elementRef.nativeElement.getElementsByClassName('menu_list')[0].classList.add('active');
    }, 0);
    this.setPosition(position);
  }

  public hide(): void {
    this.elementRef.nativeElement.getElementsByClassName('menu_list')[0].classList.remove('active');
  }

  public initSubMenu(parent: HTMLElement): void {
    this._parent = parent;
    this.elementRef.nativeElement.children[0].classList.add('is__sub_menu');
    window.addEventListener('mousemove', this.moveOutside.bind(this));
  }
}
